import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { hasCookieConsent, setCookieConsent } from '../cookie-consent';

export function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => !hasCookieConsent());

  if (!visible) {
    return null;
  }

  const handleAccept = (): void => {
    setCookieConsent('accepted');
    setVisible(false);
  };

  const handleReject = (): void => {
    setCookieConsent('rejected');
    setVisible(false);
  };

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-live="polite"
      aria-label={t('cookieConsent.ariaLabel')}
    >
      <div className="cookie-consent__inner">
        <p className="cookie-consent__text">
          {t('cookieConsent.message')}{' '}
          <Link to="/legal">{t('cookieConsent.learnMore')}</Link>
        </p>
        <div className="cookie-consent__actions">
          <button
            type="button"
            className="btn-ghost cookie-consent__reject"
            onClick={handleReject}
          >
            {t('cookieConsent.reject')}
          </button>
          <button
            type="button"
            className="btn-primary cookie-consent__accept"
            onClick={handleAccept}
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
